import { api } from './client';

export interface SLAPlan {
  id: string;
  name: string;
  description: string | null;
  is_default: boolean;
  is_pilot_default: boolean;
  frt_p1_min: number; frt_p2_min: number; frt_p3_min: number; frt_p4_min: number;
  ttr_p1_min: number; ttr_p2_min: number; ttr_p3_min: number; ttr_p4_min: number;
  working_hours_24x7: boolean;
}

export const slaApi = {
  list: () => api.get<SLAPlan[]>('/api/v1/sla-plans').then(r => r.data),
  forOrg: (orgId: string) => api.get<SLAPlan>(`/api/v1/sla-plans/_for-org/${orgId}`).then(r => r.data),
};

/** «1440 мин» → «24 ч» / «30 мин» / «3 дн». */
export function fmtMinutes(m: number): string {
  if (m < 60) return `${m} мин`;
  if (m < 60 * 24) return `${Math.round(m / 60)} ч`;
  return `${Math.round(m / 60 / 24)} дн`;
}
